import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import ParticlesBackground from '../../components/ParticlesBackground';
import { useLocalStorage } from 'react-use';
import { userLogin } from '../../helpers/api/users';
import { checkLoggedIn } from '../../helpers/checkToken';

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [token, setToken] = useLocalStorage('token', '')

    checkLoggedIn(token);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        const response = await userLogin(username, password);
        const responseBody = await response.json();

        if (responseBody.status === true) {
            const token = responseBody.token;
            setToken(token);

            setLoading(false);
            navigate('/');
        } else {
            setLoading(false);
            alert('Error Authentication');
        }
    };

    return (
        <div className="flex min-h-screen font-sans">

            {/* Left Side - Animated Background */}
            <div className="hidden lg:flex lg:w-7/12 relative flex-col items-center justify-center p-8 overflow-hidden bg-slate-800">
                
                {/* Animation Layer */}
                <ParticlesBackground 
                    color="#4ade80"
                    lineColor="rgba(74, 222, 128, 0.2)" 
                    backgroundColor="transparent"
                />

                <div className="relative z-20 text-center">
                    {/* Brand Content */}
                    <h1 className="text-6xl font-bold text-white leading-loose">
                        Welcome to <br />
                        <span className="text-green-400">G-Insight</span>
                    </h1>
                    <p className="text-xl text-white mt-0 max-w-sm mx-auto">
                        Innovative dashboard for monitoring and executive management.
                    </p>
                </div>

                 <div
                     className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-150 h-150 rounded-full z-1 pointer-events-none"
                     style={{ background: 'radial-gradient(circle, rgba(74, 222, 128, 0.1) 0%, rgba(0,0,0,0) 70%)' }}
                 ></div>
            </div>

            {/* Right Side - Login Form */}
            <div className="w-full lg:w-5/12 bg-white flex items-center justify-center p-5">
                <div className="w-full max-w-100">
                    <div className="text-center mb-6">
                        <div className="inline-flex items-center justify-center">
                            <img src="https://portal.geloraaksara.co.id/assets/img/image/LogoGAP.png" alt="Logo" className="w-80 h-auto" />
                        </div>
                        <h2 className="text-4xl font-extrabold text-gray-800 tracking-tight mb-3">
                            Welcome to <span className="text-orange-600">Gelora</span>
                        </h2>
                        <p className="text-lg font-medium text-gray-500 mt-0">Let's sign you in</p>
                    </div>

                    <form onSubmit={handleLogin}>
                        <div className="field mb-4">
                            <label htmlFor="username" className="block text-gray-700 font-medium mb-2 text-sm ml-1">Username</label>
                            <InputText
                                id="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                className="w-full p-3 border-gray-300 rounded-lg text-gray-900 bg-slate-50 login-input"
                                placeholder="Enter your username"
                                required
                            />
                        </div>

                        <div className="field mb-2">
                            <label htmlFor="password" className="block text-gray-700 font-medium mb-2 text-sm ml-1">Password</label>
                            <Password
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                toggleMask
                                feedback={false}
                                className="w-full"
                                required
                                inputClassName="w-full p-3 border-gray-300 rounded-lg text-gray-900 bg-slate-50 login-input"
                                placeholder="Enter your password"
                                pt={{
                                    root: { style: { width: '100%' } },
                                    iconField: { style: { width: '100%' } }
                                }}
                            />
                        </div>

                        <Button label="Login" className="w-full p-3 mt-4 font-bold rounded-lg transition-colors text-white border-none outline-none shadow-none login-btn" style={{ backgroundColor: '#f97316', borderColor: '#f97316' }} loading={loading} />
                    </form>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
